export default __webpack_public_path__ + "static/media/podium-2025.061ea3dd.png";